import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Aprovarplanoplanmodal from './aprovarplanoplanmodal'
import {
  fetchAprovarPlanoPlan,
  fetchUsuariosProjetoPdca,
  fetchIntegracaoProjeto,
  buscarDestinoIntegracao,
  validarDestinoIntegracao,
  gravarDestinoIntegracao,
  submitAprovarPlanoPlan,
  clearAprovarPlanoPlan
} from './redux/aprovarplanoplanActions'

import './aprovarplanoplan.scss'

const Aprovarplanoplan = ({
  open,
  close,
  planoId,
  onSuccess = () => {}
}) => {
  const dispatch = useDispatch()

  const { sistema } = useSelector(state => state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)

  const { projetoId } = useSelector(state => state.pdcaState.pdcaBaseState)

  const {
    loading,
    loadingUsers,
    loadingIntegracao,
    loadingBuscarDestino,
    loadingValidarUrl,
    loadingGravarDestino,
    submitting,
    data,
    usuarios,
    integracao,
    destinoSalvo,
    urlValidada,
    error
  } = useSelector(state => state.pdcaState.pdcaAprovarPlanoPlanState)

  useEffect(() => {
    if (open && planoId) {
      dispatch(fetchAprovarPlanoPlan(planoId))
    }
  }, [dispatch, open, planoId])

  useEffect(() => {
    if (open && projetoId) {
      dispatch(fetchUsuariosProjetoPdca(projetoId))
      dispatch(fetchIntegracaoProjeto(projetoId))
    }
  }, [dispatch, open, projetoId])

  useEffect(() => {
    if (!open) {
      dispatch(clearAprovarPlanoPlan())
    }
  }, [dispatch, open])

  useEffect(() => {
    if (open && error && !submitting && !data) {
      dispatch(clearAprovarPlanoPlan())
      close()
    }
  }, [dispatch, open, error, submitting, data, close])

  const handleClose = () => {
    dispatch(clearAprovarPlanoPlan())
    close()
  }

  /*
  const handleBuscarDestino = async () => {
    if (!projetoId) return null
    return dispatch(buscarDestinoAsana(projetoId))
  }

  const handleValidarUrl = async url => {
    if (!projetoId) return null
    return dispatch(validarUrlAsana({ projetoId, url }))
  }

  const handleGravarDestino = async urlDestino => {
    if (!projetoId) return null
    return dispatch(gravarDestinoAsana({ projetoId, urlDestino }))
  }
*/

  const handleBuscarDestino = () => {
  return dispatch(
    buscarDestinoIntegracao({
      projetoId,
      ferramentaCodigo: integracao?.ferramentaCodigo || ''
    })
  )
}

const handleValidarUrl = url => {
  return dispatch(
    validarDestinoIntegracao({
      projetoId,
      ferramentaCodigo: integracao?.ferramentaCodigo || '',
      url
    })
  )
}

const handleGravarDestino = (
  urlDestino,
  issueTypeId = null,
  listId = null,
  mondayConfig = null
) => {
  return dispatch(
    gravarDestinoIntegracao({
      projetoId,
      ferramentaCodigo: integracao?.ferramentaCodigo || '',
      urlDestino,
      issueTypeId,
      listId,
      mondayConfig
    })
  )
}



const handleGravarDestinoOLD = (urlDestino, issueTypeId = null, listId = null) => {
  return dispatch(
    gravarDestinoIntegracao({
      projetoId,
      ferramentaCodigo: integracao?.ferramentaCodigo || '',
      urlDestino,
      issueTypeId,
      listId
    })
  )
}


  const handleSubmit = async payload => {
    const result = await dispatch(submitAprovarPlanoPlan(payload))

    if (result?.ok) {
      handleClose()
      onSuccess()
      return
    }

    handleClose()
  }

  return (
    <Aprovarplanoplanmodal
      open={open}
      close={handleClose}
      loading={loading}
      loadingUsers={loadingUsers}
      loadingIntegracao={loadingIntegracao}
      loadingBuscarDestino={loadingBuscarDestino}
      loadingValidarUrl={loadingValidarUrl}
      loadingGravarDestino={loadingGravarDestino}
      submitting={submitting}
      data={data}
      usuarios={usuarios}
      integracao={integracao}
      destinoSalvo={destinoSalvo}
      urlValidada={urlValidada}
      nls={nls}
      onBuscarDestino={handleBuscarDestino}
      onValidarUrl={handleValidarUrl}
      onGravarDestino={handleGravarDestino}
      onSubmit={handleSubmit}
    />
  )
}

export default Aprovarplanoplan